// import React, { useState } from "react";
// import { Modal, Button, Form, Row, Col } from "react-bootstrap";
// import "./CreateCompanyModal.css";
// import { CompanyService } from "Services/CompanyService";
// import { toast } from "react-toastify";

// interface Props {
//   show: boolean;
//   handleClose: () => void;
//   onSuccess?: () => void;
// }

// const CreateCompanyModal: React.FC<Props> = ({
//   show,
//   handleClose,
//   onSuccess,
// }) => {
//   const [loading, setLoading] = useState(false);

//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     address: "",
//     max_candidates: 100,
//     max_exams: 15,
//     max_proctors: 10,
//     ai_features: [] as string[],
//   });

//   const handleChange = (e: any) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleCheckbox = (e: any) => {
//     const { value, checked } = e.target;

//     if (checked) {
//       setFormData({
//         ...formData,
//         ai_features: [...formData.ai_features, value],
//       });
//     } else {
//       setFormData({
//         ...formData,
//         ai_features: formData.ai_features.filter((f) => f !== value),
//       });
//     }
//   };

//   const handleSubmit = async () => {
//     try {
//       setLoading(true);

//       const payload = {
//         name: formData.name,
//         email: formData.email,
//         phone: formData.phone,
//         address: formData.address,
//         controls: {
//           max_candidates: Number(formData.max_candidates),
//           max_exams: Number(formData.max_exams),
//           max_proctors: Number(formData.max_proctors),
//         },
//         ai_features: formData.ai_features,
//       };

//       const res = await CompanyService.createCompany(payload);

//       if (res?.status === 200 || res?.status === 201) {
//         toast.success("Company created successfully");
//         onSuccess?.();
//         handleClose();
//       }
//     } catch (err: any) {
//       toast.error(
//         err?.response?.data?.message || "Failed to create company"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Modal show={show} onHide={handleClose} centered size="lg">
//       <Modal.Header closeButton className="modal-header-gradient">
//         <Modal.Title>Create New Company</Modal.Title>
//       </Modal.Header>

//       <Modal.Body>
//         <Form>
//           <h6 className="section-title">Basic Information</h6>

//           <Row className="mb-3">
//             <Col md={6}>
//               <Form.Group>
//                 <Form.Label>Company Name</Form.Label>
//                 <Form.Control
//                   name="name"
//                   value={formData.name}
//                   onChange={handleChange}
//                   placeholder="Enter company name"
//                 />
//               </Form.Group>
//             </Col>

//             <Col md={6}>
//               <Form.Group>
//                 <Form.Label>Email</Form.Label>
//                 <Form.Control
//                   name="email"
//                   type="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   placeholder="Enter email"
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           <Row className="mb-3">
//             <Col md={6}>
//               <Form.Group>
//                 <Form.Label>Phone</Form.Label>
//                 <Form.Control
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleChange}
//                   placeholder="Enter phone"
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           <Form.Group className="mb-3">
//             <Form.Label>Address</Form.Label>
//             <Form.Control
//               name="address"
//               value={formData.address}
//               onChange={handleChange}
//               placeholder="Enter address"
//             />
//           </Form.Group>

//           <h6 className="section-title">Controls</h6>

//           <Row className="mb-3">
//             <Col md={4}>
//               <Form.Group>
//                 <Form.Label>Max Candidates</Form.Label>
//                 <Form.Control
//                   type="number"
//                   name="max_candidates"
//                   value={formData.max_candidates}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             <Col md={4}>
//               <Form.Group>
//                 <Form.Label>Max Exams</Form.Label>
//                 <Form.Control
//                   type="number"
//                   name="max_exams"
//                   value={formData.max_exams}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>

//             <Col md={4}>
//               <Form.Group>
//                 <Form.Label>Max Proctors</Form.Label>
//                 <Form.Control
//                   type="number"
//                   name="max_proctors"
//                   value={formData.max_proctors}
//                   onChange={handleChange}
//                 />
//               </Form.Group>
//             </Col>
//           </Row>

//           <h6 className="section-title">AI Features</h6>

//           <Form.Check
//             type="checkbox"
//             label="Face Detection"
//             value="face detection"
//             onChange={handleCheckbox}
//           />
//           <Form.Check
//             type="checkbox"
//             label="Screen Recording"
//             value="screen recording"
//             onChange={handleCheckbox}
//           />
//         </Form>
//       </Modal.Body>

//       <Modal.Footer>
//         <Button variant="light" onClick={handleClose}>
//           Cancel
//         </Button>

//         <Button
//           className="create-btn"
//           onClick={handleSubmit}
//           disabled={loading}
//         >
//           {loading ? "Creating..." : "Create Company"}
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default CreateCompanyModal;

import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Spinner } from "react-bootstrap";
import "./CreateCompanyModal.css";
import { CompanyService } from "Services/CompanyService";
import { toast } from "react-toastify";

interface Props {
  show: boolean;
  handleClose: () => void;
  onSuccess?: () => void;
}

const CreateCompanyModal: React.FC<Props> = ({
  show,
  handleClose,
  onSuccess,
}) => {
  const [loading, setLoading] = useState(false);
  const [aiLoading, setAiLoading] = useState(false);
  const [aiOptions, setAiOptions] = useState<string[]>([]);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    max_candidates: 100,
    max_exams: 15,
    max_proctors: 10,
    ai_features: [] as string[],
  });

  
  const fetchAiFeatures = async () => {
    try {
      setAiLoading(true);
      const res = await CompanyService.getAiFeatures();

      if (res?.status === 200) {
        setAiOptions(res?.data?.data || []);
      }
    } catch (err) {
      toast.error("Failed to load AI features");
    } finally {
      setAiLoading(false);
    }
  };

  useEffect(() => {
    if (show) {
      fetchAiFeatures();
    }
  }, [show]);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckbox = (e: any) => {
    const { value, checked } = e.target;

    if (checked) {
      setFormData({
        ...formData,
        ai_features: [...formData.ai_features, value],
      });
    } else {
      setFormData({
        ...formData,
        ai_features: formData.ai_features.filter((f) => f !== value),
      });
    }
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      const payload = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        address: formData.address,
        controls: {
          max_candidates: Number(formData.max_candidates),
          max_exams: Number(formData.max_exams),
          max_proctors: Number(formData.max_proctors),
        },
        ai_features: formData.ai_features,
      };

      const res = await CompanyService.createCompany(payload);

      if (res?.status === 200 || res?.status === 201) {
        toast.success("Company created successfully");
        onSuccess?.();
        handleClose();
      }
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to create company");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton className="modal-header-gradient">
        <Modal.Title>Create New Company</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <h6 className="section-title">Basic Information</h6>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Company Name</Form.Label>
                <Form.Control
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter company name"
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Email</Form.Label>
                <Form.Control
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter email"
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Enter phone"
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Address</Form.Label>
            <Form.Control
              name="address"
              value={formData.address}
              onChange={handleChange}
              placeholder="Enter address"
            />
          </Form.Group>

          <h6 className="section-title">Controls</h6>

          <Row className="mb-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label>Max Candidates</Form.Label>
                <Form.Control
                  type="number"
                  name="max_candidates"
                  value={formData.max_candidates}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <Form.Label>Max Exams</Form.Label>
                <Form.Control
                  type="number"
                  name="max_exams"
                  value={formData.max_exams}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <Form.Label>Max Proctors</Form.Label>
                <Form.Control
                  type="number"
                  name="max_proctors"
                  value={formData.max_proctors}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <h6 className="section-title">AI Features</h6>

          {aiLoading ? (
            <div className="text-center py-3">
              <Spinner animation="border" size="sm" />
            </div>
          ) : (
            <Row>
              {aiOptions.map((feature, index) => (
                <Col md={4} sm={6} xs={12} key={index} className="mb-2">
                  <Form.Check
                    type="checkbox"
                    label={feature}
                    value={feature}
                    checked={formData.ai_features.includes(feature)}
                    onChange={handleCheckbox}
                    className="ai-feature-checkbox"
                  />
                </Col>
              ))}
            </Row>
          )}
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={handleClose}>
          Cancel
        </Button>

        <Button
          className="create-btn"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Creating..." : "Create Company"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateCompanyModal;
